import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


class YesNoModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };

        //BINDINGS
        this.close = this.close.bind(this);
        this.handlePositiveClick = this.handlePositiveClick.bind(this);
    }

    close() {
        this.props.handleClose();
    }

    handlePositiveClick() {
        this.close();
        this.props.handleYes();
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.close}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {this.props.title}
                </DialogTitle>
                <DialogContent>
                    {(typeof this.props.message) === 'string' ?
                        <DialogContentText id="alert-dialog-description">
                            {this.props.message}
                        </DialogContentText>
                        :
                        this.props.message
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.close} color="primary">
                        {this.props.negative}
                    </Button>
                    <Button onClick={this.handlePositiveClick} color="primary" autoFocus>
                        {this.props.positive}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
};

YesNoModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.any.isRequired,
    positive: PropTypes.string.isRequired,
    negative: PropTypes.string.isRequired,
    handleYes: PropTypes.func.isRequired,
};

export default YesNoModal;